import { z } from 'zod'
import { oc } from '@orpc/contract'

export const CHART_RECORD_RESOURCE_TYPES = [
  'DocumentReference',
  'DiagnosticReport',
  'RequestGroup',
] as const

export const CHART_RECORD_REMOVAL_REASONS = [
  'wrong-patient',
  'duplicate',
  'incorrect-incomplete',
  'test-training',
  'other',
] as const

const resourceRef = z.object({
  resourceType: z.enum(CHART_RECORD_RESOURCE_TYPES),
  resourceId: z.string(),
})

export const chartRecordRemove = oc
  .route({ method: 'POST', path: '/v2/chart-records/{resourceType}/{resourceId}/remove' })
  .input(
    resourceRef
      .extend({
        reason: z.enum(CHART_RECORD_REMOVAL_REASONS),
        explanation: z.string().optional(),
      })
      .refine((value) => value.reason !== 'other' || !!value.explanation?.trim(), {
        message: 'An explanation is required when reason is "other"',
        path: ['explanation'],
      }),
  )
  .output(z.object({ resourceId: z.string(), status: z.string() }))

export const chartRecordRestore = oc
  .route({ method: 'POST', path: '/v2/chart-records/{resourceType}/{resourceId}/restore' })
  .input(resourceRef)
  .output(z.object({ resourceId: z.string(), status: z.string() }))

export const chartRecordActivity = oc
  .route({ method: 'GET', path: '/v2/chart-records/{resourceType}/{resourceId}/activity' })
  .input(resourceRef)
  .output(
    z.object({
      events: z.array(
        z.object({
          id: z.string(),
          action: z.enum(['removed', 'restored']),
          recorded: z.string(),
          actor: z.string().optional(),
          reason: z.string().optional(),
          explanation: z.string().optional(),
        }),
      ),
    }),
  )
